import { Link } from "react-router-dom";
import {
  Flame,
  Cpu,
  Layers,
  Wrench,
  Stethoscope,
  BatteryCharging,
  Activity,
  Droplet,
  Settings2,
  Cog,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/data/site";

const ICONS = {
  Flame,
  Cpu,
  Layers,
  Wrench,
  Stethoscope,
  BatteryCharging,
  Activity,
  Droplet,
  Settings2,
  Cog,
};

export default function ServicesSection({ withHeader = true, limit }) {
  const list = limit ? SERVICES.slice(0, limit) : SERVICES;
  return (
    <section
      id="hizmetler"
      data-testid="services-section"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 spotlight-gold opacity-40 pointer-events-none" />
      <div className="absolute top-1/3 right-0 w-[400px] h-[400px] rounded-full bg-inci-blue/10 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {withHeader && (
          <div className="mb-14 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div>
              <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
                Hizmetlerimiz
              </p>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-balance">
                <span className="text-gradient-silver">Aracınız için </span>
                <span className="text-gradient-gold">tek elden çözüm.</span>
              </h2>
            </div>
            <p className="text-white/65 max-w-md text-base">
              LPG montajından akü değişimine, periyodik bakımdan diagnostiğe —
              her şey sertifikalı ekip ve modern ekipmanla tek adreste.
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((s, idx) => {
            const Icon = ICONS[s.icon] || Settings2;
            const accent = idx % 3 === 1 ? "blue" : "gold";
            return (
              <div
                key={s.slug}
                data-testid={`service-card-${s.slug}`}
                className={`group relative card-lift glass rounded-2xl p-7 ${
                  accent === "blue"
                    ? "hover:border-inci-blue/60 hover:shadow-[0_20px_60px_-20px_rgba(0,70,173,0.4)]"
                    : "hover:border-gold/60 hover:shadow-[0_20px_60px_-20px_rgba(212,175,55,0.4)]"
                }`}
              >
                <div className="absolute -top-px left-7 right-7 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

                <div
                  className={`w-14 h-14 rounded-xl flex items-center justify-center mb-5 transition-all duration-500 ${
                    accent === "blue"
                      ? "bg-inci-blue/15 border border-inci-blue/40 group-hover:bg-inci-blue/30 group-hover:scale-110"
                      : "bg-gold/10 border border-gold/30 group-hover:bg-gold/20 group-hover:scale-110"
                  }`}
                >
                  <Icon
                    className={`w-6 h-6 ${
                      accent === "blue" ? "text-inci-blue" : "text-gold"
                    }`}
                  />
                </div>

                <h3 className="font-display text-xl font-semibold text-white mb-2 leading-tight">
                  {s.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed mb-5">
                  {s.short}
                </p>

                <ul className="space-y-1.5 text-xs text-white/55 mb-6">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-center gap-2">
                      <span
                        className={`w-1 h-1 rounded-full ${
                          accent === "blue" ? "bg-inci-blue" : "bg-gold"
                        }`}
                      />
                      {b}
                    </li>
                  ))}
                </ul>

                <Link
                  to="/iletisim"
                  className={`inline-flex items-center gap-1 text-sm font-medium transition-colors ${
                    accent === "blue"
                      ? "text-inci-blue hover:text-inci-blue-light"
                      : "text-gold hover:text-gold-light"
                  }`}
                >
                  Teklif Al
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
